import { render } from "./CpfCnpjFieldContainer.vue?vue&type=template&id=facf413a"
import script from "./CpfCnpjFieldContainer.vue?vue&type=script&lang=js"
export * from "./CpfCnpjFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__